import { render, staticRenderFns } from "./UiPosts.vue?vue&type=template&id=959d3fc2&"
import script from "./UiPosts.vue?vue&type=script&lang=js&"
export * from "./UiPosts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports